module.exports = __webpack_public_path__ + "img/kreditz.9df5b679.png";